<style lang="scss" scoped>
    @import "./transactionLog2.css";
    .btn_cla{
		border-radius: 30px;
		padding: 0.3rem 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #ffffff;
		cursor: pointer;
		transition: opacity 0.2s;
		outline: none;
		position: relative;
	}
	.btn_cla::before {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100%;
		height: 100%;
		background-color: #000;
		border: inherit;
		border-color: #000;
		border-radius: inherit;
		transform: translate(-50%, -50%);
		opacity: 0;
		content: ' ';
	}
	.btn_cla:active::before {
		opacity: 0.1;
	}
	.warp_img{
		    width: 1.1rem;
		    margin-left:  .5rem;
	}
	.warp_title{
		text-align: center;
		color: #000;
	}
	.warp_color{
		color: #fff;
	}
    .icon_bor{
        width: 50%; 
        height: 2px;
        background-color: #5885ea;
    }
    .icon_bor1{
        width: 50%; 
        height: 2px;
        background-color: #d8d8d8;
    }
    .redX{
        position: relative;
        color: red;
        bottom: 1.2rem;
        font-size: 1.5rem;
        font-weight: 400;
    }
</style>
<style lang='scss'>
	#establishPage{
        .ant-popover-message-title{
            font-size: .8rem !important;
        }
        .ant-btn-sm{
            width: 2.8rem;
            height: 1.5rem;
            span{
                font-size: .7rem !important;
            }
        }
	}
    .pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 101;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.code_pdf .pdfviewIn {
			position: fixed;
			width: 80vw !important;
			height: 80vh !important;
			left: calc(50% - 40vw) !important;
			top: 5vh !important;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
</style>
<template>
    <div id="establishPage">
        <div class="topHeader">
            <a-form-model :model="form" style="width:100%;" labelAlign="right" layout="inline">
                <a-row style="display: flex;align-items: center;">
                    <a-col  :xl="{ span: 24 }">
                        <a-row>
                            <a-col :xl="{ span: 5 }">
                                <a-form-model-item label="信息查詢" class="formItem">
                                    <div style="display: flex;align-items: center;">
                                        <!-- <a-select v-model="form.nationcode" class="qhXz" style='width: 30%;flex-shrink: 0; margin-right: 2%;' >
                                            <a-select-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value"  :value="item.value">
                                                <span style="font-size:.8rem;">+{{ item.value }}</span>
                                            </a-select-option>
                                        </a-select> -->
                                        <a-input v-model="form.loginAccount" placeholder="請輸入登錄帳號" :allowClear="true" @change="handleClear"/>
                                    </div>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 5 }">
                                <a-form-model-item label="登錄方式" class="formItem">
                                    <a-select v-model="form.loginType" placeholder="請選擇登錄方式" @change='searchEvent(2)'>
                                        <!-- <a-select-option v-for="(item) in khtypeArr" :key="item.key" :value="item.value">{{item.text}}</a-select-option> -->
                                        <a-select-option value="">全部</a-select-option>
                                        <a-select-option value="Website">Website</a-select-option>
                                        <a-select-option value="iPhone">iPhone</a-select-option>
                                        <a-select-option value="iPad">iPad</a-select-option>
                                        <a-select-option value="Android">Android</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 5 }">
                                <a-form-model-item label="登錄結果" class="formItem">
                                    <a-select v-model="form.loginResults" placeholder="請選擇登錄結果" @change='searchEvent(2)'>
                                        <!-- <a-select-option v-for="(item) in khtypeArr" :key="item.key" :value="item.value">{{item.text}}</a-select-option> -->
                                        <a-select-option value="">全部</a-select-option>
                                        <a-select-option value="成功">成功</a-select-option>
                                        <a-select-option value="失敗">失敗</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 6 }">
                                <a-form-model-item label="登錄日期" class="formItem">
                                    <a-range-picker :placeholder="['開始時間','結束時間']" v-model="form.timeDate" @change="fanhand()"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 3 }" style="display: inline-flex;align-items: center;justify-content: flex-end;">
                                <div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
                                    <img src="../../image/icon_sousuo.png" class="btnIcon"/>
                                    <span>搜索</span>
                                </div>
                                <div class="btn_cla" style="background-color:#ffa647;" @click="clearEvent">
                                    <img src="../../image/icon_chongzhi.png" class="btnIcon"/>
                                    <span>重置</span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </a-form-model>
        </div>
        <div class="bottomMain">
            <div class="tableBtnView">
				<!-- @click='pdfEvent'  -->
				<div class='btn_list'  @click="upClick()"  style="cursor: pointer;">
					<a-icon type="file-pdf" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem'/>
					<span style="color:#3bc7a1;">導出</span>
				</div>
			</div>
            <a-table
                style="width:100%;"
                :columns="columns"
                :data-source="columnsData"
                :row-selection="{
                    selectedRowKeys: selectedRows,
                    onChange: onSelectChange,
                }"
                :pagination="false"
				id='fromtable'
				:customRow='rowstely'
                :bordered="true">
				<div slot="loginResults" slot-scope="record">
					<span v-if="record.loginResults == '成功'" style="color:#3bc7a1">{{record.loginResults}}</span>
                    <div v-else style="position: relative;">
                        <span style="color:red">{{record.loginResults}}</span>
                        <img @click="openClick(record,3)" src="../../image/ck_y.png" class="imageC" style="position:absolute;margin-left: 10px;margin-top: 4px;">
                    </div>
				</div>
				<div slot="loginAccount" slot-scope="record">
					<div v-if="record.loginAccount">{{record.loginAccount}}</div>
				</div>
				<div slot="toolArr" slot-scope="record">
					<img  @click="openClick(record,1)" src="../../image/images.png" class="imageC" style="margin-right: 15px;width:20px;">
					<img  @click="openClick(record,2)" src="../../image/down.png" class="imageC" style="width:20px;">
				</div>
            </a-table>
            <div class="paginationView">
                <div>第{{firstPage}}到{{secPage}}條，共{{total}}條記錄</div>
                <div style="margin-left:auto;">
                    <a-pagination v-model="pageNum" @change="pageChange" :total="total" :pageSize="perPage"/>
                </div>
                <div class="pageTzView">
                    <input type="text" v-model="tzPageNum" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')">
                    <span @click="tzEvent">跳轉</span>
                </div>
            </div>
        </div>
        <exportData  v-if="upFlag" @child="upclose" ></exportData>
        <div :class="['pdfview',pdfShow1 ? 'pdfShow' : '']" @click="pdfShowUNEvent1()" class="code_pdf">
            <div class="pdfviewIn" >
            <div class="pdfTitle">
                <img @click.stop="printEvent()" src="../../image/icon_dayin.png">
                <img @click.stop="downLoad()" src="../../image/icon_xiazai1.png">
            </div>
            <iframe id="iframePdf1" :src="allurl1" style="width: 100%; height: 100%" frameborder="0"></iframe>
            <iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl1" frameborder="0"></iframe>
            </div>
        </div>
        <!-- 搜索无结果弹窗 -->
        <div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
    </div>
</template>
<script>
    import exportData from "./components/exportData";
    import https from '@/plugins/http.js';
    import apiUrl from '@/assets/api.js';
    import App from '@/assets/app.js';
    import icon_renwu from '../../image/icon_renwu.png';
    import icon_renwu1 from '../../image/icon_renwu1.png';
    import icon_one from '../../image/icon_1.png';
    import icon_one1 from '../../image/icon_1_1.png';
    import icon_two from '../../image/icon/icon3.png';
    import icon_two1 from '../../image/icon/icon3_1.png';
    import { saveFileToLink,saveFileToBlob  } from 'web-downloadfile';

    export default {
		components:{
            exportData
		},
        data() {
            return {
                upFlag:false,
                qhArr: [
                    {
                    id: "1",
                    value: "86",
                    label: '中國',
                    },
                    {
                    id: "2",
                    value: "852",
                    label: '中國香港',
                    },
                    {
                    id: "3",
                    value: "853",
                    label: '中國澳門',
                    },
                    {
                    id: "4",
                    value: "61",
                    label: '澳大利亞',
                    },
                    {
                    id: "5",
                    value: "1",
                    label: '加拿大',
                    },
                    {
                    id: "6",
                    value: "60",
                    label: '馬來西亞',
                    },
                    {
                    id: "7",
                    value: "1",
                    label: '美國',
                    },
                    {
                    id: "8",
                    value: "65",
                    label: '新加坡',
                    },
                    {
                    id: "9",
                    value: "64",
                    label: '新西蘭',
                    },
                    {
                    id: "10",
                    value: "44",
                    label: '英國',
                    },
                ],
                ishandout:false,
                pdfShow1: false,
                allurl1: '',
                pdfBolUrl1: '',
                icon_renwu,
                icon_renwu1,
                icon_one,
                icon_one1,
                icon_two,
                icon_two1,

                form:{
                    nationcode:'852',
                    loginAccount:'',
                    status2:'',
                    loginType:'',
                    loginResults:'',
                    khtype:9,
                    searchstr:'',
                    username:'',
                    timeDate:[]
                },
                sendtime_begin:'',
                sendtime_end:'',
                pageNum:1,
                perPage:10,
                total:1,
                tzPageNum:'',
                columns:[
                    {title: '登錄帳號',dataIndex: '',align:'center',scopedSlots: { customRender: 'loginAccount' }},
                    {title: '登錄平台',dataIndex: 'loginPlatform',align:'center'},
                    {title: '登錄方式',dataIndex: 'loginType',align:'center'},
                    {title: '國家/地區',dataIndex: 'loginCountry',align:'center'},
                    {title: '網絡地址',dataIndex: 'ipAddress',align:'center'},
                    {title: '登錄時間',dataIndex: 'loginTime',align:'center',width:'15%'},
                    {title: '登錄結果',dataIndex: '',align:'center',scopedSlots: { customRender: 'loginResults' },width:'7%'},
                    {title: '操作',dataIndex: '',align:'center',width:'auto',scopedSlots: { customRender: 'toolArr' }},
                ],
                columnsData:[],
                // pdf彈出
                pdfShow : false,
                pdfUrl : '',
                pdfBolUrl : '',
                blob:'',
                // 任務數
                missionnum:0,
                // 證件圖標 arr
              
                selectedRows:[],
                submitusers:[],
                recordidlist:[],
                result1:[],
				
            }
        },
        created(){
            let _this = this;
            _this.messLoad();
        },
        computed: {
            firstPage: function () {
                let _this = this;
                let a = (_this.pageNum-1)*10;
                let b = 1;
                return _this.total > 0 ? Number(a) + Number(b) : 0
            },
            secPage : function(){
                let _this = this;
                let a = _this.pageNum*10;
                let b = a > _this.total ? _this.total : a;
                return b
            },
        },
		mounted() {
            // this.uploadData1()
        },
        methods: {
            upClick(){
				this.upFlag = true
			},
            upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.handopen1(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
                        // 表格导出下载
			queryData(pxfs){
                var beginTime  = ''
                var endTime = ''
                if (this.sendtime_begin) {
                    beginTime = this.sendtime_begin + ' 00:00:00'
                }
                if (this.sendtime_end) {
                    endTime = this.sendtime_end + ' 23:59:59'
                }
                let sort =  pxfs == undefined ? '' : pxfs
                let url = ''
                url = this.$api.exportTransactionLogExcel;
                // url += '?m=' + Date.parse(new Date())
                url += '?token=' + this.$store.state.token
                url += '&loginAccount=' + this.form.loginAccount
                url += '&loginType=' + this.form.loginType
                url += '&loginResults=' + this.form.loginResults
                url += '&beginTime=' + beginTime,
                url += '&endTime=' + endTime,
                url += '&sort=' + sort
				console.log(url);
				window.location.href = url;
			},
            handleClear(val){
                if (!this.form.loginAccount) {
                    this.messLoad()
                }
            },
            handleCancel(ev){
                this.ishandout = false
			},
            // uploadData1(){
            //     this.$ajax({
            //         method: "post",
            //         url: this.$api.getParamList,
            //         data: {
            //         type:'emailmodel',
            //         },
            //     }).then((res) => {
            //         if (res.data.qmiscode == 1000) {
            //         this.result1 = res.data.result
            //         } else {
            //         App.oTool.warningT(res.data.qmismsg);
            //         }
            //     });
            // },
            downLoad(){
                let _this = this;
                // saveFileToLink(_this.pdfUrl,'帳戶申請書','pdf');
                const date = new Date();
				const year = date.getFullYear();
				let month = date.getMonth() + 1;
				if (month < 10) {
					month = `0${month}`;
				}
				let day = date.getDate();
				if (day < 10) {
					day = `0${day}`;
				}
				var currentDate = `${year}${month}${day}`;
                saveFileToBlob(_this.blob,currentDate+' 在線交易日誌','pdf');
            },
            onSelectChange(selectedRowKeys, selectedRows) {
                this.selectedRows = selectedRowKeys;
                console.log(this.selectedRows,'复选框查看',selectedRows);
                this.submitusers = []
                this.recordidlist = []
                for (let i = 0; i < selectedRows.length; i++) {
                    this.recordidlist.push(selectedRows[i].recordid)
                    this.submitusers.push(selectedRows[i].pdfcode )
                }
            
            },
			rowstely(record, index) {
				if (record.finishflag == 1) {
					return {
						style: {
							'color': '#999'
						},
					}
				}
			},

            fanhand(){
                let _this = this;
                _this.sendtime_begin =_this.form.timeDate[0] ? App.oDate.secsTime3(_this.form.timeDate[0]._d) : null,
                _this.sendtime_end = _this.form.timeDate[1] ? App.oDate.secsTime3(_this.form.timeDate[1]._d) : null
            },
            messLoad(){
                var beginTime  = ''
                var endTime = ''
                if (this.sendtime_begin) {
                    beginTime = this.sendtime_begin + ' 00:00:00'
                }
                if (this.sendtime_end) {
                    endTime = this.sendtime_end + ' 23:59:59'
                }
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                https.fetchPost(apiUrl.getTransactionLog,Object.assign({
                    loginAccount:_this.form.loginAccount,
                    loginType:_this.form.loginType,
                    loginResults:_this.form.loginResults,
                    nationcode:_this.form.nationcode,
                    beginTime:beginTime,
                    endTime:endTime
                },{
                    pageCount : _this.pageNum,
                    pageSize : _this.perPage
                }),json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        _this.total = data.pageInfo.total;
                        this.columnsData = data.pageInfo.list;
                        if (this.form.loginAccount || this.form.loginType || this.form.loginResults || this.sendtime_begin) {
                            if (this.columnsData.length<=0) {
                                this.ishandout = true
                            }
                        }
                        // _this.tzPageNum = '';
   
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });
                // setTimeout(() => {
                //     if (this.recordidlist.length<=0) {
                //         this.messLoad();
                //     }
				// }, 30000);
            },
            searchEvent(){
                this.pageNum = 1;
                this.messLoad();
            },
            clearEvent(){
                this.form = {
                    nationcode:'852',
                    loginAccount:'',
                    status2:'',
                    loginType:'',
                    loginResults:'',
                    khtype:9,
                    searchstr:'',
                    username:'',
                    timeDate:[]
                }
                this.sendtime_begin = ''
                this.sendtime_end = ''
                this.messLoad();
            },

            tzEvent(){
                let _this = this;
                let maxPageNum = Math.ceil(_this.total/_this.perPage);
                if(_this.tzPageNum <= maxPageNum){
                    _this.pageNum = Number(_this.tzPageNum);
                    _this.messLoad();
                }else{
                    App.oTool.warningT('請輸入有效的頁碼');
                }
            },
            pageChange(page, pageSize){
                this.pageNum = page;
                this.messLoad();
            },

            onChange(index,bol,record){
                record.moreCheckOption[index].checked = !bol;
            },
            // 操作
            openClick(item,val){
                console.log(item.id);
                this.handopen(item,val)
            },

            //导出按钮
            handopen(item,val) {
                var beginTime  = ''
                var endTime = ''
                if (this.sendtime_begin) {
                    beginTime = this.sendtime_begin + ' 00:00:00'
                }
                if (this.sendtime_end) {
                    endTime = this.sendtime_end + ' 23:59:59'
                }
                // userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
                // if (this.userfileAuditAdmin) {
                        let str = this.$api.pdfs; //getUnsk
                        // let url = 'http://202.130.113.149:3785/admin/getQmisUserFileInfoPdf';
                        let url = ''
                        if (val == 1) {
                            url = this.$api.getTransactionLogPDF;
                        }else if(val == 2){
                            url = this.$api.downLoadTransactionLogPDF;
                        }else{
                            url = this.$api.getTransactionErrorLogPDF;
                        }
                        // url += '?m=' + Date.parse(new Date())
                        url += '?token=' + this.$store.state.token
                        url += '&loginResults=' + this.form.loginResults
                        url += '&beginTime=' + beginTime,
                        url += '&endTime=' + endTime,
                        url += '&loginAccount=' + item.loginAccount,
                        url += '&loginTime=' + item.loginTime,
                        url += '&id=' + item.id,
                        this.allurl1 = str + url
                        let _this = this;
                        _this.pdfUrl = url
                        https.fetchGetPdf(_this.pdfUrl).then((data) => {
                            let blob = new Blob([data], {
                                type: 'application/pdf'
                            });
                            _this.blob = blob;
                            let b = window.URL.createObjectURL(blob);
                            _this.pdfBolUrl1 = b;
                        }).catch(err => {
                            console.log(err);
                        });
                        //
                        setTimeout(() => {
                            this.pdfShow1 = true;
                        }, 500);
                // }else{
                //      App.oTool.warningT('暫無權限');
                // }
            },
            //导出按钮
            handopen1(pxfs) {
                var beginTime  = ''
                var endTime = ''
                if (this.sendtime_begin) {
                    beginTime = this.sendtime_begin + ' 00:00:00'
                }
                if (this.sendtime_end) {
                    endTime = this.sendtime_end + ' 23:59:59'
                }
                let sort =  pxfs == undefined ? '' : pxfs
                let str = this.$api.pdfs; //getUnsk
                let url = ''
                url = this.$api.exportTransactionLogPDF;
                // url += '?m=' + Date.parse(new Date())
                url += '?token=' + this.$store.state.token
                url += '&loginAccount=' + this.form.loginAccount
                url += '&loginType=' + this.form.loginType
                url += '&loginResults=' + this.form.loginResults
                url += '&beginTime=' + beginTime,
                url += '&endTime=' + endTime,
                url += '&sort=' + sort
                this.allurl1 = str + url
                let _this = this;
                _this.pdfUrl = url
                https.fetchGetPdf(_this.pdfUrl).then((data) => {
                    let blob = new Blob([data], {
                        type: 'application/pdf'
                    });
                    _this.blob = blob;
                    let b = window.URL.createObjectURL(blob);
                    _this.pdfBolUrl1 = b;
                }).catch(err => {
                    console.log(err);
                });
                //
                setTimeout(() => {
                    this.pdfShow1 = true;
                }, 500);
     
            },
            pdfShowUNEvent1() {
                this.pdfShow1 = false;
            },
            printEvent() {
                let _this = this; //toPrintIframe
                const printIframe = document.getElementById("toPrintIframe");
                let frameWindow = printIframe.contentWindow;
                console.log(frameWindow)
                frameWindow.print();
                setTimeout(() => {
                    window.URL.revokeObjectURL(_this.blob);
                }, 500)
            },

        },
    };

</script>


